import { render } from "./PersonalDataScreen.vue?vue&type=template&id=7d5666ea&scoped=true&lang=html"
import script from "./PersonalDataScreen.vue?vue&type=script&lang=js"
export * from "./PersonalDataScreen.vue?vue&type=script&lang=js"

import "./PersonalDataScreen.vue?vue&type=style&index=0&id=7d5666ea&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/scania_guess_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5666ea"]])

export default __exports__